import React from 'react';

import ActionButton, { ActionButtonVariants, IActionButtonProps } from 'components/action-button';
import { withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

type DeliveryAddressesButtonProps = Omit<IActionButtonProps, 'children'> & {
  children?: React.ReactNode;
};

export const AddressInfoLine = withTypography({
  variant: 'headerThree',
  style: {
    margin: 0,
  },
});

export const InfoLine = withTypography({
  variant: 'copyOne',
  fontSize: 12,
  style: {
    marginTop: spacing.$1,
  },
});

export const AliasTextInfoLine = withTypography({
  fontSize: 12,
  color: primitive.$white,
});

export const DeliveryAddressesButton = (props: DeliveryAddressesButtonProps) =>
  React.createElement(ActionButton, {
    variant: ActionButtonVariants.TEXT_ONLY,
    padding: 0,
    margin: 0,
    ...props,
  });

export const DeliveryAddressesButtonText = withTypography({
  fontFamily: 'heading',
  lineHeight: '2xs',
  style: {
    padding: spacing.$2,
  },
});

export const DeliveryAddressesName = withTypography({
  fontFamily: 'heading',
  fontSize: 'sm',
  focusable: true,
  numberOfLines: 2,
  style: {
    margin: 0,
  },
});
